export default __webpack_public_path__ + "static/media/asset-t-zero.afa9af31.svg";